export function defaultReviewImg (){
const img = document.getElementsByClassName("review-pic");
for (var i = 0; i < img.length; i++) {
img[i].addEventListener("error", function(event: any) {
  event.target.src = "/us/en-us/_assets/images/customer-reviews/noun_profile.svg"
  event.onerror = null
})
}
}